
export const initialValues = {
  groupName: "",
  stages: "",
  rules: "",
  offers: "",
  activeStatus: 1,

}